import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('drawer');

    return {
        CLOSE_TEXT: t('closeText'),
        OPEN_TEXT: t('openText')
    };
};

export default useTranslation;
